"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _react3 = require("@floating-ui/react");
var _classnames = _interopRequireDefault(require("classnames"));
var _Layout = require("../Layout");
var _MenuContext = require("./MenuContext");
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const InnerMenuItems = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    style,
    keepMounted,
    selected,
    ...props
  } = _ref;
  const {
    floating,
    overlayData: {
      refs,
      getFloatingProps,
      floatingStyles
    }
  } = (0, _MenuContext.useMenuContext)();
  const refProp = (0, _react3.useMergeRefs)([refs.setFloating, ref]);
  const {
    theme: {
      menu: {
        items: itemsTheme
      }
    }
  } = (0, _Theme.useThemeConfig)();
  return /*#__PURE__*/_react.default.createElement(_react2.Menu.Items, {
    as: _react.Fragment,
    static: keepMounted
  }, /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    as: "ul",
    ref: refProp,
    p: itemsTheme.container.p,
    bg: itemsTheme.container.bg,
    shadow: itemsTheme.container.shadow,
    rounded: itemsTheme.container.rounded,
    focus: itemsTheme.container.focus,
    selected: selected,
    style: {
      ...style,
      ...(floating ? floatingStyles : {})
    },
    className: (0, _classnames.default)(className, {
      [itemsTheme.container.z]: floating
    })
  }, floating ? getFloatingProps(props) : props), children));
});
InnerMenuItems.displayName = "InnerMenuItems";
const MenuItems = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    floating
  } = (0, _MenuContext.useMenuContext)();
  const {
    theme: {
      menu: {
        items: itemsTheme
      }
    }
  } = (0, _Theme.useThemeConfig)();
  return floating ? /*#__PURE__*/_react.default.createElement(_react3.FloatingPortal, null, /*#__PURE__*/_react.default.createElement(_react2.Transition, {
    as: _react.Fragment,
    leave: itemsTheme.transition.leave,
    leaveFrom: itemsTheme.transition.leaveFrom,
    leaveTo: itemsTheme.transition.leaveTo
  }, /*#__PURE__*/_react.default.createElement(InnerMenuItems, _extends({
    ref: ref
  }, props)))) : /*#__PURE__*/_react.default.createElement(InnerMenuItems, _extends({
    ref: ref
  }, props));
});
exports.MenuItems = MenuItems;
MenuItems.displayName = "Menu.Items";